import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { VideoContextWrapper } from "./context/video";
import { WhiteBackground } from "../../../components/WhiteBackground";

export function VideoListingV2() {
  const [count, setCount] = useState(0);
  const [searchFilter, setSearchFilter] = React.useState<any>({
    searchValue: "",
    productId: null,
  });

  return (
    <WhiteBackground>
      <VideoContextWrapper>
        <Outlet context={[searchFilter, setSearchFilter, count, setCount]} />
      </VideoContextWrapper>
    </WhiteBackground>
  );
}
